export const PENDING = "PENDING"
export const ERROR = "ERROR"
export const SUCCESS = "SUCCESS"